module.exports = __webpack_public_path__ + "static/media/lWealth.dbc2b514.png";